module.exports = __webpack_public_path__ + "static/img/kf_cloud_00008.41d7c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00008.jpg
// module id = 179
// module chunks = 1